<template>
  <div>
    <div v-if="timer <= 0">
      <div>
        <span v-if="!data.loan_offers.length">{{
          "wait_5min"
            | setText(
              "Требуется время для проверки лимита. Нажмите далее, чтобы проверить"
            )
        }}</span>
        <h4 v-else>{{ "sentences" | setText("Предложения") }}:</h4>
        <div class="mb-2" v-for="(offer, key) in data.loan_offers" :key="key">
          {{ "month_count_is" | setText("Количество месяцев") }}:
          {{ offer.term }} {{ "limit_is" | setText("Предлагаемый лимит") }}:
          {{ offer.total_amount }}
        </div>
      </div>

      <div class="install-control">
        <button
          v-if="!data.loan_offers.length"
          @click="getData"
          class="btn btn-success"
        >
          {{ "next_step" | setText("Далее") }}
        </button>

        <button v-else @click="send" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
    <div v-else>
      <h4 class="text-info">
        {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
        {{ "second" | setText("сек.") }}
      </h4>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {},
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  async created() {},
  methods: {
    send() {
      this.$emit("setStep", "customer-data");
      this.$emit("input", this.data);
    },
    getData() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}get-offers/${this.transaction["exchange_id"]}?type=Limit`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
      })
        .then((response) => {
          
          if (response.data) {
            if (response.data.loan_id) {
              this.data.loan_id = response.data.loan_id;
              this.data.loan_offers = response.data.loan_offers;
            } else {
              this.timer = 30;
            }

            if (response.data.message && response.data.code) {
              this.$notify({
                title: response.data.code,
                message: response.data.message,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        loan_offers: [],
        loan_id: null,
      },
      timer: 0,
    };
  },
};
</script>

